import { useMutation } from '@tanstack/react-query';
import axios, { AxiosError } from 'axios';

import {
  InsurancePaymentIntentData,
  InsurancePaymentIntentError,
  InsurancePaymentIntentRequest,
} from '@/types/insurance';
import { API } from '@/utils/apiConstants';

const CONFIRM_PAYMENT_INTENT_KEY = 'confirmPaymentIntent';

const confirmPaymentIntent = async (
  data: InsurancePaymentIntentRequest,
): Promise<InsurancePaymentIntentData> => {
  const response = await axios.post<InsurancePaymentIntentData>(
    `${API.baseEndpoint}/api/v1/buyer_insurance/offer_on_tracking/payment_intent/confirm`,
    data,
    {
      headers: {
        'Content-Type': 'application/json',
      },
    },
  );

  return response.data;
};

export const useConfirmPaymentIntent = () => {
  return useMutation<
    InsurancePaymentIntentData,
    AxiosError<InsurancePaymentIntentError>,
    InsurancePaymentIntentRequest
  >({
    mutationKey: [CONFIRM_PAYMENT_INTENT_KEY],
    mutationFn: confirmPaymentIntent,
  });
};
